import { SelectorDateTimeWithControl } from '../SelectorDateTime';
export function SelectorDateWithControl(props) {
  return <SelectorDateTimeWithControl {...props} type="date" />;
}